import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsMealAssignmentStudentDataParmInfo } from "./wsMealAssignmentStudentDataParmInfo";
import { wsMealAssignmentMealSubsidyTypeAssignParm } from "./wsMealAssignmentMealSubsidyTypeAssignParm";

@Injectable()
export class DataService_mealassignment {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentMealSubsidyTypeSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentMealSubsidyTypeSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/MealAssignmentMealSubsidyTypeSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentAssignmentDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentAssignmentDataGet(parms: wsMealAssignmentStudentDataParmInfo) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/MealAssignmentStudentAssignmentDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentMealSubsidyTypeAssign
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentMealSubsidyTypeAssign(parms: wsMealAssignmentMealSubsidyTypeAssignParm) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/MealAssignmentStudentMealSubsidyTypeAssign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentMealSubsidyTypeUnAssign
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentMealSubsidyTypeUnAssign(parms: wsMealAssignmentMealSubsidyTypeAssignParm) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/MealAssignmentStudentMealSubsidyTypeUnAssign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
